export class TechnologiesModel {
  id: number;
  name: string;
  icons: string;
  color: string;
  status: boolean;
  active?: boolean;
  isExistId:boolean;
}
